import { createSelector } from '@reduxjs/toolkit';
import { searchSelectors } from '@sv-support-sdk/store';

import { mapResultList } from '../../helpers/search';
import { RootState } from '..';

export const {
  selectSearchValue,
  selectResultCount,
  selectSelectedSearchScopes,
  selectPagination,
  selectLoading,
} = searchSelectors;

export const selectDropdownList = (state: RootState) => state.search.dropdownResultList;
export const selectList = (state: RootState) => state.search.resultList;

export const selectResultList = createSelector(selectList, mapResultList);

export const selectDropdownResultList = createSelector(selectDropdownList, mapResultList);
